module.exports = __webpack_public_path__ + "static/img/btn.e7febc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperation/btn.png
// module id = pNl8
// module chunks = 36